import React from 'react';
import LoginForm from './LoginForm';
import BannerItem from './BannerItem';
import NotificationList from '../../shared/components/NotificationList';

const Main: React.FC = () => {
  return (
    <React.Fragment>
      <main id="page-facility" className="wrapper">
        <NotificationList path="welcome" />
        <section className="sec-correct">
          <div className="inner">
            <div className="correct-box">
              <div className="correct-box__banner">
                <div className="correct-box__banner-full">
                  <picture>
                    <source srcSet={`${process.env.PUBLIC_URL}/img/webp/index/mv-sp.webp`}  media="(max-width:834px)" type="image/webp" />
                    <source srcSet={`${process.env.PUBLIC_URL}/img/index/mv-sp.png`} media="(max-width:834px)" />
                    <source srcSet={`${process.env.PUBLIC_URL}/img/webp/index/mv.webp`} type="image/webp" />
                    <img src={`${process.env.PUBLIC_URL}/img/index/mv.png`} alt="お取引先ページ（ご注文等）はこちら" />
                  </picture>
                </div>
                <ul className="correct-box__banner-list">
                  <BannerItem
                    src={`${process.env.PUBLIC_URL}/img/index/bnr_01.png`}
                    srcSet={{
                      webp: `${process.env.PUBLIC_URL}/img/webp/index/bnr_01-sp.webp`,
                      png: `${process.env.PUBLIC_URL}/img/index/bnr_01-sp.png`,
                      fullWebp: `${process.env.PUBLIC_URL}/img/webp/index/bnr_01.webp`
                    }}
                    alt="レンズ製品のご紹介"
                    href="https://www.seed.co.jp/orthokeratology/orthokeratology.html"
                  />
                  <BannerItem
                    src={`${process.env.PUBLIC_URL}/img/index/bnr_02.png`}
                    srcSet={{
                      webp: `${process.env.PUBLIC_URL}/img/webp/index/bnr_02-sp.webp`,
                      png: `${process.env.PUBLIC_URL}/img/index/bnr_02-sp.png`,
                      fullWebp: `${process.env.PUBLIC_URL}/img/webp/index/bnr_02.webp`
                    }}
                    alt="ケア用品のご紹介"
                    href="https://www.seed.co.jp/products/care/orthokeratology/"
                  />
                </ul>
              </div>
              <LoginForm />
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
};

export default Main;